import LikesApi from '../api/LikesApi';
import LikesConstants from '../constants/LikesConstants';

export function addLike({ apiFailure = null, contentId, postSuccess }) {
  return {
    types: [LikesConstants.ADD_LIKE_REQUEST, LikesConstants.ADD_LIKE_SUCCESS, LikesConstants.ADD_LIKE_FAILURE],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (_state, client) =>
      LikesApi.addLike(
        {
          contentId
        },
        client
      ),
    apiFailure,
    postSuccess
  };
}

function removeLikeSuccess(id) {
  return {
    deletedEntities: [`ugc.likes.${id}`]
  };
}

export function removeLike({ id, contentId, postSuccess }) {
  return {
    types: [LikesConstants.REMOVE_LIKE_REQUEST, LikesConstants.REMOVE_LIKE_SUCCESS, LikesConstants.REMOVE_LIKE_FAILURE],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      LikesApi.removeLike(
        {
          contentId
        },
        client
      ),
    apiSuccess: () => removeLikeSuccess(id),
    postSuccess
  };
}

export function getLikes({ contentId, size, page }) {
  return {
    types: [LikesConstants.GET_LIKES_REQUEST, LikesConstants.GET_LIKES_SUCCESS, LikesConstants.GET_LIKES_FAILURE],
    apiRequest: (state, client) =>
      LikesApi.getLikes(
        {
          contentId,
          size,
          page
        },
        client
      )
  };
}

export default { addLike, removeLike, getLikes };
